import {createSlice} from '@reduxjs/toolkit';

const repairIdSlice = createSlice({
  name: 'repairId',
  initialState: {value: undefined as string | undefined},
  reducers: {
    setRepairId: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const {setRepairId} = repairIdSlice.actions;
export const selectRepairId = (state: {repairId: {value: string | undefined}}) => state.repairId.value;
export default repairIdSlice.reducer;
